import { MasterPayrollObject } from '../../../models/payroll';

export function IsPayDateInvalid(payroll: MasterPayrollObject | null) {
  if (payroll != null) {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
    const payDateString: any = payroll.PayDate;
    const payDate = new Date(Date.parse(payDateString));
    const normalizedPayDate = new Date(
      payDate.getFullYear(),
      payDate.getMonth(),
      payDate.getDate(),
      0,
      0,
      0,
      0
    );
    return normalizedPayDate < today;
  }
  return false;
}
